import { useAuth } from '@/hooks/use-auth';
import { Logo } from '@/components/viz/Logo';
import { SupportLink } from '@/components/ui';

export function PendingApprovalPage() {
  const { signOut, user } = useAuth();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-void px-4">
      <div className="max-w-md w-full text-center">
        <div className="flex items-center justify-center gap-3 mb-8">
          <Logo size={28} />
          <span className="text-xl font-mono font-bold tracking-widest text-text-bright">
            ARCANUM
          </span>
        </div>

        <div className="bg-panel-bg border border-panel-border rounded-lg p-8 mb-6">
          <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-accent-dim flex items-center justify-center">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              className="text-accent"
            >
              <circle cx="12" cy="12" r="10" />
              <polyline points="12 6 12 12 16 14" />
            </svg>
          </div>

          <h2 className="text-lg font-semibold text-text-bright mb-2">
            Account Under Review
          </h2>

          <p className="text-sm text-text-muted leading-relaxed mb-4">
            Your account has been created and is pending admin approval. You'll
            receive access once an administrator has reviewed your request.
          </p>

          <p className="text-xs text-text-dim">Signed in as {user?.email}</p>

          {/* Locked-out users get the primary path to reach a human while
              they wait for approval — this surface has no other CTA besides
              Sign out, so making support discoverable here is high-leverage. */}
          <div className="mt-4 pt-4 border-t border-panel-border">
            <SupportLink variant="inline" subject="Approval status inquiry" />
          </div>
        </div>

        <button
          onClick={() => signOut()}
          className="text-sm text-text-muted hover:text-text transition-colors cursor-pointer"
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
